import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "./ui/card";
import { Skeleton } from "./ui/skeleton";

const PropCardSkeleton = () => {
  return (
    <Card className="p-2 sm:p-4 w-full shadow-card rounded-2xl">
      <CardHeader>
        <CardTitle>
          <Skeleton className="h-56 w-full rounded-lg" />
        </CardTitle>
      </CardHeader>
      <CardContent className="mt-6 *:h-6 space-y-4">
        <Skeleton className="w-full " />
        <div className="flex gap-4 *:basis-1/2">
          <Skeleton />
          <Skeleton />
        </div>
        <Skeleton className="w-1/2 " />
      </CardContent>
    </Card>
  );
};

export default PropCardSkeleton;
